// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3ZPXh","userAvatar":"styles_userAvatar__2S_Fc","avatar":"styles_avatar__z3atO"};